import { gql } from '@apollo/client'

export default gql(`
query listAppPages($limit: Int $project: String) {
    listAppPages(
      limit: $limit,
      project: $project
    ) {
      items {
        id
        isArchived
        isPublished
        createdBy
        createdAt
        key
        project
        publishStartDate
        publishEndDate
        title
        group{
          key
          name
          type
        }
      }
    }
}`)
